import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import SystemExperienceForm from '../components/SystemExperienceForm';

const SystemExperiencePage = () => {
  const [systems, setSystems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingSystem, setEditingSystem] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchSystems();
  }, []);

  const fetchSystems = async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/systems-experience');
      setSystems(response.data || []);
    } catch (err) {
      setError('Failed to load systems');
      setSystems([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddSystem = () => {
    setEditingSystem(null);
    setShowModal(true);
  };

  const handleEditSystem = (system) => {
    setEditingSystem(system);
    setShowModal(true);
  };

  const handleDeleteSystem = async (id) => {
    if (!window.confirm('Are you sure you want to delete this system?')) {
      return;
    }

    try {
      await apiClient.delete(`/systems-experience/${id}`);
      setSystems(systems.filter(s => s.id !== id));
      showSuccess('System deleted successfully');
    } catch (err) {
      setError('Failed to delete system');
    }
  };

  const handleSaveSystem = async (systemData) => {
    try {
      if (editingSystem) {
        const response = await apiClient.put(`/systems-experience/${editingSystem.id}`, systemData);
        setSystems(systems.map(s => s.id === editingSystem.id ? response.data : s));
        showSuccess('System updated successfully');
      } else {
        const response = await apiClient.post(`/systems-experience`, systemData);
        setSystems([...systems, response.data]);
        showSuccess('System created successfully');
      }
      setShowModal(false);
    } catch (err) {
      setError('Failed to save system');
    }
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  return (
    <div>
      <div className="content-header">
        <h2>System Experience Management</h2>
        <button className="add-btn" onClick={handleAddSystem}>
          + Add New System
        </button>
      </div>

      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      {isLoading ? (
        <div className="table-container">
          <div className="no-data">Loading systems...</div>
        </div>
      ) : systems.length === 0 ? (
        <div className="table-container">
          <div className="no-data">No systems yet. Add your first system!</div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {systems.map(system => (
            <div key={system.id} className="message-card" style={{ borderLeftColor: '#9b59b6' }}>
              <h4 style={{ fontSize: '20px' }}>{system.icon} {system.title}</h4>
              <div style={{ color: '#667eea', fontSize: '13px', marginBottom: '10px' }}>
                {system.category}
              </div>
              <p>{system.description}</p>
              <div className="action-buttons" style={{ marginTop: '10px' }}>
                <button className="edit-btn" onClick={() => handleEditSystem(system)}>
                  Edit
                </button>
                <button className="delete-btn" onClick={() => handleDeleteSystem(system.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <SystemExperienceForm
              system={editingSystem}
              onSave={handleSaveSystem}
              onCancel={() => setShowModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemExperiencePage;
